import {makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const footerStyles = makeStyles((theme: Theme) =>
  createStyles({
    footerContainer:{
        display:'flex',
        width:'100%',
        justifyContent:'space-evenly',
        alignItems:'center',
        backgroundColor:'#D32F2F',
        color:'white',
        marginTop: 'auto'
    },
    menuInfoContainer:{
        textAlign:'center',
        '& span':{
            margin:'8px',
        }
    },
    logoContainer:{
        textAlign:'center',
    },
    logo:{
        width:'250px',
        height:'120px',
        margin:'40px',
        [theme.breakpoints.down('sm')]:{
            width:'200px',
            height:'100px',
            margin:'5px',
        }
    },
    contactContainer:{
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
    }
  }),
);

export default footerStyles;